(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7873],{

/***/ 33844:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hiring-process-comparison",
      function () {
        return __webpack_require__(55038);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 95805:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _instanceof = (__webpack_require__(70237)/* ["default"] */ .Z);
"client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _extends = (__webpack_require__(59419)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(2784));
var _loadable = _interop_require_default(__webpack_require__(42060));
function dynamic(dynamicOptions, options) {
    var loadableFn = _loadable.default;
    var loadableOptions = (options == null ? void 0 : options.suspense) ? {} : {
        // A loading component is not required, so we default it
        loading: function(param) {
            var error = param.error, isLoading = param.isLoading, pastDelay = param.pastDelay;
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (_instanceof(dynamicOptions, Promise)) {
        loadableOptions.loader = function() {
            return dynamicOptions;
        };
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === "function") {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === "object") {
        loadableOptions = _extends({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _extends({}, loadableOptions, options);
    // Error if Fizz rendering is not enabled and `suspense` option is set to true
    if ( true && loadableOptions.suspense) {
        throw new Error("Invalid suspense option usage in next/dynamic. Read more: https://nextjs.org/docs/messages/invalid-dynamic-suspense");
    }
    if (loadableOptions.suspense) {
        if (false) {}
        delete loadableOptions.ssr;
        delete loadableOptions.loading;
    }
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
    // skip `ssr` for suspense mode and opt-in React.lazy directly
    if (typeof loadableOptions.ssr === "boolean" && !loadableOptions.suspense) {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
}
"client";
var isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    var Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return function() {
        return /*#__PURE__*/ _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
    };
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 46941:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(2784));
var LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 42060:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _classCallCheck = (__webpack_require__(60616)/* ["default"] */ .Z);
var _createClass = (__webpack_require__(90416)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _extends = (__webpack_require__(59419)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(2784));
var _loadableContext = __webpack_require__(46941);
var useSyncExternalStore = ( false ? 0 : __webpack_require__(43100)).useSyncExternalStore;
var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];
var initialized = false;
function load(loader) {
    var promise = loader();
    var state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then(function(loaded) {
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch(function(err) {
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    var init = function init() {
        if (!subscription) {
            var sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    };
    var useLoadableModule = function useLoadableModule() {
        init();
        var context = _react.default.useContext(_loadableContext.LoadableContext);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach(function(moduleName) {
                context(moduleName);
            });
        }
    };
    var LoadableImpl = function LoadableImpl(props, ref) {
        useLoadableModule();
        var state = useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);
        _react.default.useImperativeHandle(ref, function() {
            return {
                retry: subscription.retry
            };
        }, []);
        return _react.default.useMemo(function() {
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    };
    var LazyImpl = function LazyImpl(props, ref) {
        useLoadableModule();
        return _react.default.createElement(opts.lazy, _extends({}, props, {
            ref: ref
        }));
    };
    var opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    /** @type LoadableSubscription */ var subscription = null;
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== "undefined") {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        var moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push(function(ids) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = moduleIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var moduleId = _step.value;
                        if (ids.indexOf(moduleId) !== -1) {
                            return init();
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            });
        }
    }
    var LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = function() {
        return init();
    };
    LoadableComponent.displayName = "LoadableComponent";
    return _react.default.forwardRef(LoadableComponent);
}
var LoadableSubscription = /*#__PURE__*/ function() {
    function LoadableSubscription(loadFn, opts) {
        _classCallCheck(this, LoadableSubscription);
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
    _createClass(LoadableSubscription, [
        {
            key: "promise",
            value: function promise() {
                return this._res.promise;
            }
        },
        {
            key: "retry",
            value: function retry() {
                var _this = this;
                this._clearTimeouts();
                this._res = this._loadFn(this._opts.loader);
                this._state = {
                    pastDelay: false,
                    timedOut: false
                };
                var ref = this, res = ref._res, opts = ref._opts;
                if (res.loading) {
                    if (typeof opts.delay === "number") {
                        if (opts.delay === 0) {
                            this._state.pastDelay = true;
                        } else {
                            this._delay = setTimeout(function() {
                                _this._update({
                                    pastDelay: true
                                });
                            }, opts.delay);
                        }
                    }
                    if (typeof opts.timeout === "number") {
                        this._timeout = setTimeout(function() {
                            _this._update({
                                timedOut: true
                            });
                        }, opts.timeout);
                    }
                }
                this._res.promise.then(function() {
                    _this._update({});
                    _this._clearTimeouts();
                }).catch(function(_err) {
                    _this._update({});
                    _this._clearTimeouts();
                });
                this._update({});
            }
        },
        {
            key: "_update",
            value: function _update(partial) {
                this._state = _extends({}, this._state, {
                    error: this._res.error,
                    loaded: this._res.loaded,
                    loading: this._res.loading
                }, partial);
                this._callbacks.forEach(function(callback) {
                    return callback();
                });
            }
        },
        {
            key: "_clearTimeouts",
            value: function _clearTimeouts() {
                clearTimeout(this._delay);
                clearTimeout(this._timeout);
            }
        },
        {
            key: "getCurrentValue",
            value: function getCurrentValue() {
                return this._state;
            }
        },
        {
            key: "subscribe",
            value: function subscribe(callback) {
                var _this = this;
                this._callbacks.add(callback);
                return function() {
                    _this._callbacks.delete(callback);
                };
            }
        }
    ]);
    return LoadableSubscription;
}();
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    var promises = [];
    while(initializers.length){
        var init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(function() {
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = function() {
    return new Promise(function(resolveInitializers, reject) {
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = function() {
    var ids = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return new Promise(function(resolvePreload) {
        var res = function() {
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 12109:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$t": function() { return /* binding */ StyledFaqsHeader; },
/* harmony export */   "Ie": function() { return /* binding */ StyledWebFaqs; },
/* harmony export */   "s5": function() { return /* binding */ StyledFaqsSection; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var components_shared_Typography__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99655);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40286);
/* harmony import */ var _theme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90408);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  max-width: ",
        ";\n  width: 100%;\n  margin: auto;\n  padding: ",
        " ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: center;\n  max-width: ",
        ";\n  font-size: ",
        ";\n  margin-bottom: ",
        ";\n\n  ",
        " {\n    margin-bottom: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: auto;\n  max-width: ",
        ";\n  border-bottom: 1px solid ",
        ";\n  counter-reset: faqs;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var StyledFaqsSection = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-73f69e31-0"
})(_templateObject(), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .container */ .nC)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xl6"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("md"));
var StyledFaqsHeader = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-73f69e31-1"
})(_templateObject1(), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .container */ .nC)("sm"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .fontSize */ .JB)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("lg"), components_shared_Typography__WEBPACK_IMPORTED_MODULE_1__/* .Heading2 */ .XJ, (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .screen */ .sp)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xl4"));
var StyledWebFaqs = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].dl.withConfig */ .ZP.dl.withConfig({
    componentId: "sc-73f69e31-2"
})(_templateObject2(), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .container */ .nC)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$_)("midnight_200"));


/***/ }),

/***/ 29372:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var components_marketingSite_shared_FaqsItem__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53307);
/* harmony import */ var components_shared_Typography__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99655);
/* harmony import */ var _Faqs_styled__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12109);




var Faqs = function(param) {
    var faqs = param.faqs, title = param.title, desc = param.desc, h3 = param.h3;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: faqs && faqs.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Faqs_styled__WEBPACK_IMPORTED_MODULE_3__/* .StyledFaqsSection */ .s5, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Faqs_styled__WEBPACK_IMPORTED_MODULE_3__/* .StyledFaqsHeader */ .$t, {
                    children: [
                        !h3 && title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_shared_Typography__WEBPACK_IMPORTED_MODULE_2__/* .Heading2 */ .XJ, {
                            editorial: true,
                            children: title
                        }),
                        h3 && title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_shared_Typography__WEBPACK_IMPORTED_MODULE_2__/* .Heading3 */ .aC, {
                            editorial: true,
                            children: title
                        }),
                        desc && typeof desc === "object" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            children: desc
                        }),
                        typeof desc === "string" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            dangerouslySetInnerHTML: {
                                __html: desc || ""
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Faqs_styled__WEBPACK_IMPORTED_MODULE_3__/* .StyledWebFaqs */ .Ie, {
                    children: faqs === null || faqs === void 0 ? void 0 : faqs.map(function(faq, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_marketingSite_shared_FaqsItem__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                            renderComponent: faq.renderComponent,
                            question: faq.question,
                            answer: faq.answer,
                            anchor: faq.anchor,
                            active: faq.active
                        }, index);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Faqs);


/***/ }),

/***/ 73412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97729);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45847);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var utils_config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75339);
/* harmony import */ var _HeadMetadataLangAlternate__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21646);






var HeadMetadata = function(param) {
    var title = param.title, url = param.url, _desc = param.desc, desc = _desc === void 0 ? "" : _desc, imgUrl = param.imgUrl, path = param.path, _indexable = param.indexable, indexable = _indexable === void 0 ? false : _indexable, _extraMeta = param.extraMeta, extraMeta = _extraMeta === void 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}) : _extraMeta;
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)().locale;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: desc || ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: desc || ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: imgUrl || "https://www.getmanfred.com/og-image.jpg"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:site",
                        content: "@getmanfred"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:creator",
                        content: "@getmanfred"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:description",
                        content: desc || ""
                    }),
                    imgUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:image",
                        content: imgUrl
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: desc || ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:site_name",
                        content: "Get Manfred"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:locale",
                        content: locale
                    }),
                    url && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                property: "og:url",
                                content: "".concat(utils_config__WEBPACK_IMPORTED_MODULE_4__/* .config.appUrl */ .v.appUrl).concat(url.langs["es"])
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                                rel: "canonical",
                                href: "".concat(utils_config__WEBPACK_IMPORTED_MODULE_4__/* .config.appUrl */ .v.appUrl).concat(url.langs["es"])
                            })
                        ]
                    }),
                    indexable && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "robots",
                        content: "index,follow"
                    }),
                    extraMeta
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_3___default()), {
                id: "globalLDMetadata",
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: '{\n          "@context": "https://schema.org",\n          "@type": "Organization",\n          "name": "Manfred",\n          "url": "https://www.getmanfred.com/",\n          "logo": "https://www.getmanfred.com/favicon.ico",\n          "description": "Plataforma de empleo para profesionales del sector tecnol\xf3gico.",\n          "sameAs": [\n            "https://twitter.com/getmanfred",\n            "https://www.linkedin.com/company/getmanfred/",\n            "https://github.com/getmanfred>"\n          ],\n          "contactPoint": [\n            {\n              "@type": "ContactPoint",\n              "email": "support@getmanfred.com",\n              "contactType": "customer service",\n              "availableLanguage": ["Spanish", "English"]\n            }\n          ],\n          "founder": {\n            "@type": "Person",\n            "name": "David Bonilla",\n            "url": "https://twitter.com/david_bonilla>"\n          },\n          "foundingDate": "2019",\n          "areaServed": "Worldwide",\n          "address": {\n            "@type": "PostalAddress",\n            "addressCountry": "ES",\n            "addressRegion": "Madrid",\n            "addressLocality": "Madrid"\n          },\n          "offers": {\n            "@type": "Service",\n            "name": "Plataforma de empleo para el sector tech",\n            "description": "Conectamos profesionales tecnol\xf3gicos con empresas mediante un enfoque centrado en la privacidad y la transparencia."\n          }\n        }'
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_HeadMetadataLangAlternate__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                url: url,
                path: path
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HeadMetadata);


/***/ }),

/***/ 21646:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97729);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var services_multilingual_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21428);
/* harmony import */ var utils_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75339);




var HeadMetadataLangAlternate = function(param) {
    var url = param.url, path = param.path;
    var getPath = function getPath(path, locale) {
        if (!path) {
            return "";
        }
        return "/".concat((0,services_multilingual_service__WEBPACK_IMPORTED_MODULE_3__/* .getTranslatedText */ .G)(path, locale));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: url && Object.keys(url.langs).map(function(key) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "alternate",
                hrefLang: key,
                href: "".concat(utils_config__WEBPACK_IMPORTED_MODULE_2__/* .config.appUrl */ .v.appUrl, "/").concat(key).concat(url.langs[key]).concat(getPath(path, key))
            }, key);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HeadMetadataLangAlternate);


/***/ }),

/***/ 55038:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ hiring_process_comparison; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./components/layout/Page.tsx + 19 modules
var Page = __webpack_require__(24882);
// EXTERNAL MODULE: ./components/marketingSite/shared/Faqs.tsx
var Faqs = __webpack_require__(29372);
// EXTERNAL MODULE: ./hooks/useI18n/index.ts + 1 modules
var useI18n = __webpack_require__(39105);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(40286);
// EXTERNAL MODULE: ./theme/index.js + 247 modules
var theme = __webpack_require__(90408);
;// CONCATENATED MODULE: ./components/marketingSite/hiringProcessComparison/HPCComponent.styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var StyledFaqs = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b77edc38-0"
})(_templateObject(), (0,theme/* color */.$_)("sand_100"));

// EXTERNAL MODULE: ../../node_modules/@fortawesome/pro-solid-svg-icons/index.mjs
var pro_solid_svg_icons = __webpack_require__(54933);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(49929);
// EXTERNAL MODULE: ./components/shared/ButtonLink.js
var ButtonLink = __webpack_require__(68692);
// EXTERNAL MODULE: ./components/shared/Typography.js
var Typography = __webpack_require__(99655);
// EXTERNAL MODULE: ./components/shared/Typography.styled.tsx
var Typography_styled = __webpack_require__(90637);
// EXTERNAL MODULE: ./utils/paths.tsx
var paths = __webpack_require__(64516);
;// CONCATENATED MODULE: ./components/marketingSite/hiringProcessComparison/sections/addProcess/HPCAddProcess.styled.ts

function HPCAddProcess_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: auto;\n  padding: ",
        ";\n  max-width: ",
        ";\n  width: 100%;\n  background-image: url('",
        "');\n  background-repeat: no-repeat;\n  background-size: contain;\n  background-position: left top;\n  overflow: hidden;\n\n  @media (min-width: ",
        ") {\n    background-position: center center;\n  }\n"
    ]);
    HPCAddProcess_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  position: relative;\n\n  @media (min-width: ",
        ") {\n    padding-top: ",
        ";\n    padding-bottom: ",
        ";\n    padding-left: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    padding-left: ",
        ";\n    max-width: ",
        ";\n  }\n\n  &::after {\n    content: '';\n    position: absolute;\n    right: 0rem;\n    top: -2.5rem;\n    width: 5rem;\n    height: 5.5rem;\n    background-image: url('",
        "');\n    background-size: contain;\n\n    @media (min-width: ",
        ") {\n      right: -17rem;\n      top: 2rem;\n      width: 15rem;\n      height: 16rem;\n    }\n  }\n\n  ",
        " {\n    @media (max-width: ",
        ") {\n      padding-right: ",
        ";\n      margin-top: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-49e524a6-0"
})(HPCAddProcess_styled_templateObject(), (0,theme/* spacing */.W0)("md"), (0,theme/* container */.nC)("xl"), (0,paths/* getPublicPath */.A)("/images/comparison/cta-bg.svg"), (0,theme/* screen */.sp)("md"));
var StyledContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-49e524a6-1"
})(_templateObject1(), (0,theme/* container */.nC)("xs"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("xl6"), (0,theme/* spacing */.W0)("xl6"), (0,theme/* spacing */.W0)("xl"), (0,theme/* screen */.sp)("lg"), (0,theme/* spacing */.W0)("xl7"), (0,theme/* container */.nC)("md"), (0,paths/* getPublicPath */.A)("/images/comparison/planet.svg"), (0,theme/* screen */.sp)("md"), Typography_styled/* Heading2 */.XJ, (0,theme/* screen */.sp)("mdMax"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("xl3"));

;// CONCATENATED MODULE: ./components/marketingSite/hiringProcessComparison/sections/addProcess/HPCAddProcess.tsx







var HPCAddProcess = function() {
    var t = (0,useI18n/* useI18n */.Q)("hiring-process-comparison").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContent, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading2 */.XJ, {
                    editorial: true,
                    alignLeft: true,
                    children: t("hiring-process-comparison.add_process.title")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: t("hiring-process-comparison.add_process.desc")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonLink/* ButtonLink */.Z, {
                    href: "https://form.typeform.com/to/OoHs7m3N?source=WebCTA",
                    target: "_blank",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                            icon: pro_solid_svg_icons/* faCheckCircle */.f8k
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: t("hiring-process-comparison.add_process.cta")
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var addProcess_HPCAddProcess = (HPCAddProcess);

;// CONCATENATED MODULE: ./components/marketingSite/hiringProcessComparison/sections/companies/HPCCompanies.styled.ts

function HPCCompanies_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n"
    ]);
    HPCCompanies_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function HPCCompanies_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        " ",
        ";\n  max-width: ",
        ";\n  margin: auto;\n  text-align: center;\n"
    ]);
    HPCCompanies_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: ",
        " ",
        ";\n  margin-top: ",
        ";\n  margin-bottom: ",
        ";\n\n  img {\n    max-height: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: ",
        " auto;\n  text-transform: uppercase;\n  color: ",
        ";\n  font-weight: ",
        ";\n  position: relative;\n\n  span {\n    background-color: ",
        ";\n    padding-left: ",
        ";\n    padding-right: ",
        ";\n    z-index: 1;\n    position: relative;\n  }\n\n  &::before {\n    content: '';\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 50%;\n    height: 1px;\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var StyledSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ee22ab65-0"
})(HPCCompanies_styled_templateObject(), (0,theme/* color */.$_)("midnight_100"));
var HPCCompanies_styled_StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ee22ab65-1"
})(HPCCompanies_styled_templateObject1(), (0,theme/* spacing */.W0)("xl5"), (0,theme/* spacing */.W0)("md"), (0,theme/* container */.nC)("xl"));
var StyledCompanies = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ee22ab65-2"
})(_templateObject2(), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl"));
var StyledMore = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ee22ab65-3"
})(_templateObject3(), (0,theme/* container */.nC)("sm"), (0,theme/* spacing */.W0)("xl"), (0,theme/* color */.$_)("text_subtle"), (0,theme/* fontWeight */.Ue)("extraBold"), (0,theme/* color */.$_)("midnight_100"), (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("xs"), (0,theme/* color */.$_)("midnight_200"));

;// CONCATENATED MODULE: ./components/marketingSite/hiringProcessComparison/sections/companies/HPCCompanies.tsx







var HPCCompanies = function(param) {
    var content = param.content;
    var t = (0,useI18n/* useI18n */.Q)("hiring-process-comparison").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSection, {
        id: "companies",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HPCCompanies_styled_StyledContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading2 */.XJ, {
                    editorial: true,
                    children: t("hiring-process-comparison.available_companies.title")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCompanies, {
                    children: content === null || content === void 0 ? void 0 : content.sort(function(a, b) {
                        return a.attributes.relevantCompanyPosition - b.attributes.relevantCompanyPosition;
                    }).map(function(param) {
                        var id = param.id, attributes = param.attributes;
                        return attributes.relevantCompanyPosition > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: attributes.logoRelevant.data.attributes.url,
                            alt: attributes.companyName
                        }, id);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMore, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: t("hiring-process-comparison.available_companies.more")
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonLink/* ButtonLink */.Z, {
                    href: "https://form.typeform.com/to/OoHs7m3N?source=WebCTA",
                    target: "_blank",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                            icon: pro_solid_svg_icons/* faCheckCircle */.f8k
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: t("hiring-process-comparison.available_companies.cta")
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var companies_HPCCompanies = (HPCCompanies);

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/pro-light-svg-icons/index.mjs
var pro_light_svg_icons = __webpack_require__(38914);
// EXTERNAL MODULE: ./components/shared/Dropdown.tsx + 1 modules
var Dropdown = __webpack_require__(25728);
// EXTERNAL MODULE: ./components/shared/TooltipMF.tsx
var TooltipMF = __webpack_require__(83885);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-slick/lib/index.js
var lib = __webpack_require__(23467);
// EXTERNAL MODULE: ./services/service.event-tracking.ts + 1 modules
var service_event_tracking = __webpack_require__(27862);
;// CONCATENATED MODULE: ./components/marketingSite/hiringProcessComparison/sections/comparison/HPCComparison.styled.ts

function HPCComparison_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        " ",
        ";\n  max-width: ",
        ";\n  width: 100%;\n  margin: auto;\n  text-align: center;\n"
    ]);
    HPCComparison_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function HPCComparison_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  margin-top: ",
        ";\n  margin-bottom: ",
        ";\n  gap: ",
        ";\n"
    ]);
    HPCComparison_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function HPCComparison_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: ",
        ";\n"
    ]);
    HPCComparison_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function HPCComparison_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        " ",
        ";\n  border: 2px solid ",
        ";\n  border-radius: ",
        ";\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  background: transparent;\n  cursor: pointer;\n\n  svg {\n    width: ",
        " !important;\n  }\n"
    ]);
    HPCComparison_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        " ",
        ";\n  border: 2px solid ",
        ";\n  border-radius: ",
        ";\n  background-color: transparent;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n\n  img {\n    height: ",
        ";\n    width: auto;\n  }\n\n  &.is-active {\n    border-color: ",
        ";\n    background-color: ",
        ";\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: ",
        ";\n  margin-bottom: ",
        ";\n\n  .slick-slider {\n    padding-bottom: 0;\n    padding-top: calc(",
        " + ",
        ");\n  }\n\n  .slick-track {\n    display: flex;\n    gap: ",
        ";\n  }\n\n  .slick-dots {\n    bottom: unset;\n    top: 0;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-width: 18rem;\n  display: flex !important;\n  flex-direction: column;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-self: center;\n  align-items: center;\n  gap: ",
        ";\n  padding: ",
        " calc(",
        " + ",
        ")\n    ",
        " ",
        ";\n  margin-bottom: ",
        ";\n  background-color: ",
        ";\n  border-radius: ",
        ";\n  font-weight: ",
        ";\n  position: relative;\n\n  img {\n    height: ",
        ";\n    display: block;\n  }\n\n  button {\n    position: absolute;\n    right: ",
        ";\n    background-color: transparent;\n    border: 0;\n    padding: ",
        ";\n    width: ",
        ";\n    height: ",
        ";\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: ",
        ";\n    transition: 0.3s;\n    cursor: pointer;\n\n    &:hover {\n      background-color: ",
        ";\n    }\n\n    svg {\n      width: ",
        " !important;\n      height: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: ",
        ";\n  background-color: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n\n  svg {\n    color: ",
        ";\n    width: ",
        " !important;\n    height: ",
        ";\n  }\n\n  span {\n    cursor: pointer;\n    color: ",
        ";\n\n    &:hover {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.333;\n  font-weight: ",
        ";\n  margin-bottom: ",
        ";\n\n  svg {\n    width: ",
        " !important;\n    height: ",
        ";\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: ",
        ";\n  margin-right: ",
        ";\n  margin-top: ",
        ";\n  padding-top: ",
        ";\n  border-top: 2px solid ",
        ";\n  font-size: ",
        ";\n  line-height: 1.333;\n  font-weight: ",
        ";\n  text-transform: uppercase;\n  color: ",
        ";\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: ",
        ";\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 3.25rem;\n  height: 3.25rem;\n  border-radius: ",
        ";\n  background-color: ",
        ";\n  border: 2px solid ",
        ";\n  color: ",
        ";\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.25;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        " ",
        " ",
        ";\n  min-height: 16.75rem;\n  position: relative;\n  font-size: ",
        ";\n  line-height: 1.428;\n\n  &::after {\n    content: '';\n    position: absolute;\n    bottom: -",
        ";\n    left: 0;\n    right: 0;\n    height: ",
        ";\n    clip-path: polygon(0 0, 100% 0, 50% 100%);\n    z-index: 1;\n    transform: translateY(-0.5px);\n  }\n\n  &:first-of-type {\n    background-color: ",
        ";\n    padding-top: ",
        ";\n\n    &::after {\n      background-color: ",
        ";\n    }\n  }\n\n  &:nth-of-type(2) {\n    background-color: ",
        ";\n\n    &::after {\n      background-color: ",
        ";\n    }\n  }\n\n  &:nth-of-type(3) {\n    background-color: ",
        ";\n\n    &::after {\n      background-color: ",
        ";\n    }\n  }\n\n  &:nth-of-type(4) {\n    background-color: ",
        ";\n\n    &::after {\n      background-color: ",
        ";\n    }\n  }\n\n  &:nth-of-type(5) {\n    background-color: ",
        ";\n    color: ",
        ";\n\n    &::after {\n      background-color: ",
        ";\n    }\n\n    ",
        " svg {\n      color: ",
        ";\n    }\n\n    ",
        " {\n      color: ",
        ";\n    }\n  }\n\n  &:nth-of-type(6) {\n    background-color: ",
        ";\n    color: ",
        ";\n\n    &::after {\n      background-color: ",
        ";\n    }\n\n    ",
        " svg {\n      color: ",
        ";\n    }\n\n    ",
        " {\n      color: ",
        ";\n    }\n  }\n\n  &:nth-of-type(7) {\n    background-color: ",
        ";\n    color: ",
        ";\n\n    &::after {\n      background-color: ",
        ";\n    }\n\n    ",
        " svg {\n      color: ",
        ";\n    }\n\n    ",
        " {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 0;\n  margin-bottom: ",
        ";\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: 1;\n  font-weight: ",
        ";\n  text-transform: uppercase;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  padding: ",
        " ",
        " ",
        ";\n  border-bottom: ",
        " solid ",
        ";\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  font-size: ",
        ";\n  text-transform: uppercase;\n  font-weight: ",
        ";\n\n  svg {\n    color: ",
        ";\n    width: ",
        " !important;\n    height: ",
        ";\n  }\n\n  h4 {\n    margin: 0;\n    font-family: ",
        ";\n    font-size: ",
        ";\n    line-height: 1;\n    font-weight: ",
        ";\n    text-transform: uppercase;\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: ",
        ";\n  text-align: center;\n  margin: ",
        " auto;\n\n  svg {\n    color: ",
        ";\n    width: ",
        " !important;\n    height: ",
        ";\n  }\n\n  p {\n    margin: 0;\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  line-height: 1.2;\n  font-weight: ",
        ";\n  margin: 0;\n  color: ",
        ";\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}


var HPCComparison_styled_StyledSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9068d364-0"
})(HPCComparison_styled_templateObject(), (0,theme/* spacing */.W0)("xl5"), (0,theme/* spacing */.W0)("md"), (0,theme/* container */.nC)("xl"));
var StyledFilters = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9068d364-1"
})(HPCComparison_styled_templateObject1(), (0,theme/* spacing */.W0)("xl2"), (0,theme/* spacing */.W0)("xl2"), (0,theme/* spacing */.W0)("xs"));
var StyledMainFilters = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9068d364-2"
})(HPCComparison_styled_templateObject2(), (0,theme/* spacing */.W0)("xs"));
var StyledTrigger = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-9068d364-3"
})(HPCComparison_styled_templateObject3(), (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("md"), (0,theme/* color */.$_)("midnight_200"), (0,theme/* radius */.q0)("full"), (0,theme/* spacing */.W0)("xs"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* fontWeight */.Ue)("extraBold"), (0,theme/* spacing */.W0)("md"));
var StyledFilter = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-9068d364-4"
})(_templateObject4(), (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("md"), (0,theme/* color */.$_)("midnight_200"), (0,theme/* radius */.q0)("full"), (0,theme/* spacing */.W0)("xs"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* fontWeight */.Ue)("extraBold"), (0,theme/* spacing */.W0)("md"), (0,theme/* color */.$_)("navy_800"), (0,theme/* color */.$_)("active"), (0,theme/* color */.$_)("text_over_active"));
var StyledFiltersDropdown = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9068d364-5"
})(_templateObject5());
var StyledProcesses = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9068d364-6"
})(_templateObject6(), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl2"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("xl"));
var StyledProcess = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9068d364-7"
})(_templateObject7());
var StyledBadge = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9068d364-8"
})(_templateObject8(), (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("mdlg"), (0,theme/* color */.$_)("midnight_100"), (0,theme/* radius */.q0)("full"), (0,theme/* fontWeight */.Ue)("extraBold"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("sm"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl"), (0,theme/* radius */.q0)("full"), (0,theme/* color */.$_)("midnight_200"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("lg"));
var StyledSource = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9068d364-9"
})(_templateObject9(), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("xs"), (0,theme/* color */.$_)("midnight_100"), (0,theme/* fontWeight */.Ue)("extraBold"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* color */.$_)("text_subtle"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* color */.$_)("link"), (0,theme/* color */.$_)("link_hover"));
var StyledStepDays = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9068d364-10"
})(_templateObject10(), (0,theme/* spacing */.W0)("xs2"), (0,theme/* fontSize */.JB)("xs"), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* color */.$_)("navy_600"));
var StyledStepConversion = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9068d364-11"
})(_templateObject11(), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("sm"), (0,theme/* color */.$_)("white"), (0,theme/* fontSize */.JB)("xs"), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* color */.$_)("navy_500"), (0,theme/* spacing */.W0)("xs"));
var StyledStepConversionNumber = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9068d364-12"
})(_templateObject12(), (0,theme/* radius */.q0)("full"), (0,theme/* color */.$_)("navy_900"), (0,theme/* color */.$_)("white"), (0,theme/* color */.$_)("text_white"), (0,theme/* fontFamily */.I8)("serif"), (0,theme/* fontWeight */.Ue)("bold"), (0,theme/* fontSize */.JB)("md"));
var StyledStep = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9068d364-13"
})(_templateObject13(), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl"), (0,theme/* color */.$_)("navy_100"), (0,theme/* spacing */.W0)("xl"), (0,theme/* color */.$_)("navy_100"), (0,theme/* color */.$_)("navy_150"), (0,theme/* color */.$_)("navy_150"), (0,theme/* color */.$_)("navy_200"), (0,theme/* color */.$_)("navy_200"), (0,theme/* color */.$_)("navy_300"), (0,theme/* color */.$_)("navy_300"), (0,theme/* color */.$_)("navy_500"), (0,theme/* color */.$_)("text_white"), (0,theme/* color */.$_)("navy_500"), StyledStepDays, (0,theme/* color */.$_)("navy_200"), StyledStepConversion, (0,theme/* color */.$_)("text_white"), (0,theme/* color */.$_)("navy_600"), (0,theme/* color */.$_)("text_white"), (0,theme/* color */.$_)("navy_600"), StyledStepDays, (0,theme/* color */.$_)("navy_200"), StyledStepConversion, (0,theme/* color */.$_)("text_white"), (0,theme/* color */.$_)("navy_700"), (0,theme/* color */.$_)("text_white"), (0,theme/* color */.$_)("navy_700"), StyledStepDays, (0,theme/* color */.$_)("navy_200"), StyledStepConversion, (0,theme/* color */.$_)("text_white"));
var StyledStepTitle = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    componentId: "sc-9068d364-14"
})(_templateObject14(), (0,theme/* spacing */.W0)("md"), (0,theme/* fontFamily */.I8)("display"), (0,theme/* fontSize */.JB)("xl2"), (0,theme/* fontWeight */.Ue)("semiBold"));
var StyledHired = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9068d364-15"
})(_templateObject15(), (0,theme/* color */.$_)("white"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xs2"), (0,theme/* color */.$_)("emerald_400"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* fontWeight */.Ue)("extraBold"), (0,theme/* color */.$_)("emerald_500"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* fontFamily */.I8)("display"), (0,theme/* fontSize */.JB)("xl2"), (0,theme/* fontWeight */.Ue)("semiBold"), (0,theme/* color */.$_)("emerald_700"));
var StyledEmpty = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9068d364-16"
})(_templateObject16(), (0,theme/* container */.nC)("sm"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("xl5"), (0,theme/* color */.$_)("midnight_300"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* fontSize */.JB)("sm"));
var StyledEmptyTitle = styled_components_browser_esm/* default.h5.withConfig */.ZP.h5.withConfig({
    componentId: "sc-9068d364-17"
})(_templateObject17(), (0,theme/* fontSize */.JB)("lg"), (0,theme/* fontWeight */.Ue)("extraBold"), (0,theme/* color */.$_)("text_subtle"));

;// CONCATENATED MODULE: ./components/marketingSite/hiringProcessComparison/sections/comparison/HPCEmpty.tsx





var HPCEmpty = function() {
    var t = (0,useI18n/* useI18n */.Q)("hiring-process-comparison").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledEmpty, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                icon: pro_light_svg_icons/* faEmptySet */.ImE
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledEmptyTitle, {
                children: t("hiring-process-comparison.process_comparison.empty_title")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: t("hiring-process-comparison.process_comparison.empty_desc")
            })
        ]
    });
};
/* harmony default export */ var comparison_HPCEmpty = (HPCEmpty);

;// CONCATENATED MODULE: ./components/marketingSite/hiringProcessComparison/sections/comparison/HPCComparison.tsx
















var HPCComparison = function(param) {
    var content = param.content;
    var t = (0,useI18n/* useI18n */.Q)("hiring-process-comparison").t;
    var sliderSettings = {
        dots: true,
        arrows: false,
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 680,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    };
    var ref = (0,react.useState)([]), filteredCompanies = ref[0], setFilteredCompanies = ref[1];
    var ref1 = (0,react.useState)(false), filterMenuOpen = ref1[0], setFilterMenuOpen = ref1[1];
    var ref2 = (0,react.useState)(true), initialRender = ref2[0], setInitialRender = ref2[1];
    var companySelected = function(id) {
        if (!filteredCompanies.find(function(e) {
            return e.id === id;
        })) {
            var company = content === null || content === void 0 ? void 0 : content.find(function(e) {
                return e.id === id;
            });
            setFilteredCompanies(function(filteredCompanies) {
                return [
                    company
                ].concat((0,_to_consumable_array/* default */.Z)(filteredCompanies));
            });
            setInitialRender(false);
            service_event_tracking/* default.track */.Z.track({
                type: "Website - Hiring Processes Landing Interaction",
                properties: {
                    objectName: company.attributes.companyName,
                    action: "add"
                }
            });
        } else {
            setFilteredCompanies(function(filteredCompanies) {
                return filteredCompanies.filter(function(e) {
                    return e.id != id;
                });
            });
            setInitialRender(false);
        }
    };
    var removeCompany = function(id) {
        setFilteredCompanies(function(filteredCompanies) {
            return filteredCompanies.filter(function(e) {
                return e.id != id;
            });
        });
        setInitialRender(false);
    };
    var checkCompanyState = function(id) {
        if (filteredCompanies.find(function(e) {
            return e.id === id;
        })) {
            return true;
        } else {
            return false;
        }
    };
    var companiesArray = [];
    content === null || content === void 0 ? void 0 : content.sort(function(a, b) {
        return a.attributes.companyName.toLowerCase().localeCompare(b.attributes.companyName.toLowerCase());
    }).forEach(function(e) {
        if (e.attributes.filterPosition > 0) {
            return;
        }
        var element = {
            label: e.attributes.companyName,
            value: e.attributes.companyName,
            action: function() {
                companySelected(e.id);
                setFilterMenuOpen(false);
            },
            activeClassCondition: filteredCompanies.find(function(z) {
                return z.id === e.id;
            })
        };
        companiesArray.push(element);
    });
    var node = (0,react.useRef)(null);
    var handleCloseFilterMenu = function(e) {
        var ref;
        if ((ref = node.current) === null || ref === void 0 ? void 0 : ref.contains(e.target)) {
            return;
        }
        setFilterMenuOpen(false);
    };
    (0,react.useEffect)(function() {
        document.addEventListener("mousedown", handleCloseFilterMenu);
        return function() {
            document.removeEventListener("mousedown", handleCloseFilterMenu);
        };
    }, []);
    (0,react.useEffect)(function() {
        var ref;
        var params = new URLSearchParams(window.location.search);
        var paramsIdArray = (ref = params.get("companies")) === null || ref === void 0 ? void 0 : ref.split(",");
        if (!!paramsIdArray && paramsIdArray.length > 0 && paramsIdArray[0] !== "") {
            var filteredContent = [];
            paramsIdArray === null || paramsIdArray === void 0 ? void 0 : paramsIdArray.forEach(function(e) {
                var _filteredContent;
                var arrEl = content === null || content === void 0 ? void 0 : content.filter(function(el) {
                    return el.id === parseInt(e);
                });
                (_filteredContent = filteredContent).push.apply(_filteredContent, (0,_to_consumable_array/* default */.Z)(arrEl || []));
            });
            setFilteredCompanies(filteredContent);
        } else {
            content === null || content === void 0 ? void 0 : content.sort(function(a, b) {
                return a.attributes.defaultColumnNumber - b.attributes.defaultColumnNumber;
            }).forEach(function(e) {
                if (e.attributes.defaultColumnNumber > 0) {
                    setFilteredCompanies(function(filteredCompanies) {
                        return (0,_to_consumable_array/* default */.Z)(filteredCompanies).concat([
                            e
                        ]);
                    });
                }
            });
        }
    }, [
        content
    ]);
    (0,react.useEffect)(function() {
        if (!initialRender) {
            var companiesIds = [];
            filteredCompanies.forEach(function(e) {
                companiesIds.push(e.id);
            });
            window.history.replaceState({}, "", "?companies=".concat(companiesIds).concat(window.location.hash));
        }
    }, [
        filteredCompanies,
        initialRender
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(HPCComparison_styled_StyledSection, {
        id: "comparator",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading2 */.XJ, {
                editorial: true,
                children: t("hiring-process-comparison.process_comparison.title")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFilters, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMainFilters, {
                        children: content === null || content === void 0 ? void 0 : content.sort(function(a, b) {
                            return a.attributes.filterPosition - b.attributes.filterPosition;
                        }).map(function(param) {
                            var id = param.id, attributes = param.attributes;
                            return attributes.filterPosition > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFilter, {
                                onClick: function() {
                                    return companySelected(id);
                                },
                                className: "".concat(checkCompanyState(id) ? "is-active" : ""),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: attributes.logoMini.data.attributes.url,
                                        alt: attributes.companyName
                                    }),
                                    attributes.companyName
                                ]
                            }, id);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFiltersDropdown, {
                        ref: node,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFilter, {
                                "aria-controls": "filter-menu",
                                onClick: function() {
                                    return setFilterMenuOpen(!filterMenuOpen);
                                },
                                children: [
                                    t("hiring-process-comparison.process_comparison.show_more_companies"),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                        icon: pro_light_svg_icons/* faAngleDown */.gc2
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* default */.Z, {
                                id: "filter-menu",
                                options: companiesArray,
                                style: {
                                    display: filterMenuOpen ? "block" : "none"
                                },
                                hasFilter: true,
                                filterPlaceholder: t("hiring-process-comparison.process_comparison.search_companies") || ""
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledProcesses, {
                children: [
                    filteredCompanies.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sliderSettings), {
                        children: filteredCompanies.map(function(param) {
                            var id = param.id, attributes = param.attributes;
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledProcess, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledBadge, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: attributes.logoMini.data.attributes.url,
                                                alt: attributes.companyName
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: attributes.companyName
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                onClick: function() {
                                                    return removeCompany(id);
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                    icon: pro_light_svg_icons/* faTimes */.NBC
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSource, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                icon: pro_solid_svg_icons/* faBookSpells */.W9J
                                            }),
                                            attributes.sourceLink && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: attributes.sourceLink,
                                                target: "_blank",
                                                rel: "noreferrer",
                                                children: t("hiring-process-comparison.process_comparison.source")
                                            }),
                                            !attributes.sourceLink && /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipMF/* default */.Z, {
                                                content: t("hiring-process-comparison.process_comparison.source_empty"),
                                                direction: "up",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: t("hiring-process-comparison.process_comparison.source")
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: attributes.hiring_process_steps.data.sort(function(a, b) {
                                            return a.attributes.order - b.attributes.order;
                                        }).map(function(param) {
                                            var id = param.id, attributes = param.attributes;
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledStep, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledStepTitle, {
                                                        children: attributes.title
                                                    }),
                                                    attributes.days && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledStepDays, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                                icon: pro_light_svg_icons/* faClock */.SZw
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                children: [
                                                                    t("hiring-process-comparison.process_comparison.duration"),
                                                                    " ",
                                                                    t("hiring-process-comparison.process_comparison.duration_day", {
                                                                        count: attributes.days
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: attributes.description
                                                    }),
                                                    attributes.conversion && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledStepConversion, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledStepConversionNumber, {
                                                                children: [
                                                                    attributes.conversion,
                                                                    "%"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: t("hiring-process-comparison.process_comparison.conversion")
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }, id);
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHired, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                icon: pro_light_svg_icons/* faCheckCircle */.f8k
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: attributes.finalStepText ? attributes.finalStepText : t("hiring-process-comparison.process_comparison.hired_weeks")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                children: t("hiring-process-comparison.process_comparison.hired")
                                            })
                                        ]
                                    })
                                ]
                            }, id);
                        })
                    })),
                    filteredCompanies.length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(comparison_HPCEmpty, {})
                ]
            })
        ]
    });
};
/* harmony default export */ var comparison_HPCComparison = (HPCComparison);

;// CONCATENATED MODULE: ./components/marketingSite/hiringProcessComparison/sections/hero/HPCHero.styled.ts

function HPCHero_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-image: linear-gradient(\n    180deg,\n    ",
        ",\n    ",
        "\n  );\n\n  @media (min-width: ",
        ") {\n    background-image: url('",
        "'),\n      linear-gradient(180deg, ",
        ", ",
        ");\n    background-repeat: no-repeat;\n    background-position: top right, top left;\n    background-size: contain, cover;\n  }\n\n  @media (min-width: ",
        ") {\n    background-image: url('",
        "'),\n      linear-gradient(180deg, ",
        ", ",
        ");\n    background-position: top left calc(50% + 350px), top left;\n    background-size: contain, cover;\n  }\n"
    ]);
    HPCHero_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function HPCHero_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: auto;\n"
    ]);
    HPCHero_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function HPCHero_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 ",
        " ",
        ";\n  max-width: ",
        ";\n  color: ",
        ";\n  line-height: 1.5;\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n    line-height: 1.6;\n    padding: ",
        " ",
        " ",
        ";\n  }\n"
    ]);
    HPCHero_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var StyledHero = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-eaa3ba9a-0"
})(HPCHero_styled_templateObject(), (0,theme/* color */.$_)("navy_900"), (0,theme/* color */.$_)("navy_800"), (0,theme/* screen */.sp)("md"), (0,paths/* getPublicPath */.A)("/images/comparison/hero.svg"), (0,theme/* color */.$_)("navy_900"), (0,theme/* color */.$_)("navy_800"), (0,theme/* screen */.sp)("xl"), (0,paths/* getPublicPath */.A)("/images/comparison/hero-xl.svg"), (0,theme/* color */.$_)("navy_900"), (0,theme/* color */.$_)("navy_800"));
var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-eaa3ba9a-1"
})(HPCHero_styled_templateObject1(), (0,theme/* container */.nC)("xlMax"));
var HPCHero_styled_StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-eaa3ba9a-2"
})(HPCHero_styled_templateObject2(), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("xl2"), (0,theme/* container */.nC)("sm"), (0,theme/* color */.$_)("text_white"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("lg"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("xl5"));

;// CONCATENATED MODULE: ./components/marketingSite/hiringProcessComparison/sections/hero/HPCHero.tsx







var HPCHero = function() {
    var t = (0,useI18n/* useI18n */.Q)("hiring-process-comparison").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHero, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWrapper, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HPCHero_styled_StyledContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading1 */.nL, {
                        editorial: true,
                        alignLeft: true,
                        children: t("hiring-process-comparison.hero.title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: t("hiring-process-comparison.hero.desc")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonLink/* ButtonLink */.Z, {
                        href: "#comparator",
                        variant: "brandTalent",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                icon: pro_solid_svg_icons/* faCheckCircle */.f8k
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: t("hiring-process-comparison.hero.cta")
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var hero_HPCHero = (HPCHero);

;// CONCATENATED MODULE: ./components/marketingSite/hiringProcessComparison/sections/tips/HPCTips.styled.ts

function HPCTips_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        " ",
        ";\n  max-width: ",
        ";\n  margin: auto;\n  text-align: center;\n"
    ]);
    HPCTips_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function HPCTips_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  margin-top: ",
        ";\n"
    ]);
    HPCTips_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function HPCTips_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: ",
        ";\n  text-align: left;\n\n  @media (min-width: ",
        ") {\n    text-align: right;\n  }\n\n  > div {\n    @media (min-width: ",
        ") {\n      width: 50%;\n    }\n  }\n\n  p {\n    margin-bottom: ",
        ";\n  }\n\n  ",
        " {\n    margin-top: ",
        ";\n\n    &::before {\n      left: 0;\n      transform: unset;\n      @media (min-width: ",
        ") {\n        right: 0;\n        left: unset;\n      }\n    }\n  }\n  @media (min-width: ",
        ") {\n    &:nth-child(even) {\n      flex-direction: row-reverse;\n      text-align: left;\n\n      ",
        "::before {\n        right: unset;\n        left: 0;\n      }\n    }\n  }\n"
    ]);
    HPCTips_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function HPCTips_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n\n  img {\n    display: none;\n\n    @media (min-width: ",
        ") {\n      display: block;\n      object-fit: cover;\n      width: 100%;\n      height: 100%;\n      position: absolute;\n    }\n  }\n"
    ]);
    HPCTips_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var HPCTips_styled_StyledSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-61e84926-0"
})(HPCTips_styled_templateObject(), (0,theme/* spacing */.W0)("xl5"), (0,theme/* spacing */.W0)("md"), (0,theme/* container */.nC)("xl"));
var StyledTips = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-61e84926-1"
})(HPCTips_styled_templateObject1(), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("xl3"));
var StyledTip = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-61e84926-2"
})(HPCTips_styled_templateObject2(), (0,theme/* spacing */.W0)("xl"), (0,theme/* screen */.sp)("md"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("lg"), Typography_styled/* Heading3 */.aC, (0,theme/* spacing */.W0)("md"), (0,theme/* screen */.sp)("md"), (0,theme/* screen */.sp)("md"), Typography_styled/* Heading3 */.aC);
var StyledTipImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-61e84926-3"
})(HPCTips_styled_templateObject3(), (0,theme/* screen */.sp)("md"));

;// CONCATENATED MODULE: ./components/marketingSite/hiringProcessComparison/sections/tips/HPCTips.tsx







var HPCTips = function(param) {
    var tips = param.tips;
    var t = (0,useI18n/* useI18n */.Q)("hiring-process-comparison").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(HPCTips_styled_StyledSection, {
        id: "tips",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading2 */.XJ, {
                editorial: true,
                children: t("hiring-process-comparison.tips.title")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTips, {
                children: tips === null || tips === void 0 ? void 0 : tips.sort(function(a, b) {
                    return a.attributes.order - b.attributes.order;
                }).map(function(param) {
                    var id = param.id, attributes = param.attributes;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTip, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading3 */.aC, {
                                        editorial: true,
                                        children: attributes.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: attributes.description
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonLink/* ButtonLink */.Z, {
                                        href: attributes.link,
                                        target: "_blank",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                icon: pro_solid_svg_icons/* faCheckCircle */.f8k
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: attributes.buttonText
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTipImage, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: attributes.image.data.attributes.url,
                                    alt: attributes.image.data.attributes.alternativeText
                                })
                            })
                        ]
                    }, id);
                })
            })
        ]
    });
};
/* harmony default export */ var tips_HPCTips = (HPCTips);

;// CONCATENATED MODULE: ./components/marketingSite/hiringProcessComparison/HPCComponent.tsx










var HPCComponent = function(param) {
    var content = param.content, tips = param.tips, faqs = param.faqs;
    var t = (0,useI18n/* useI18n */.Q)("hiring-process-comparison").t;
    var faqsArray = (faqs === null || faqs === void 0 ? void 0 : faqs.sort(function(a, b) {
        return a.attributes.order - b.attributes.order;
    }).map(function(faq) {
        return {
            question: faq.attributes.question,
            answer: faq.attributes.answer
        };
    })) || [];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Page/* default */.ZP, {
        pageVariant: "light",
        hasScrollTop: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(hero_HPCHero, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(companies_HPCCompanies, {
                content: content
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(comparison_HPCComparison, {
                content: content
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(addProcess_HPCAddProcess, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(tips_HPCTips, {
                tips: tips
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFaqs, {
                id: "faqs",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Faqs/* default */.Z, {
                    faqs: faqsArray,
                    title: t("hiring-process-comparison.faqs.title")
                })
            })
        ]
    });
};
/* harmony default export */ var hiringProcessComparison_HPCComponent = (HPCComponent);

// EXTERNAL MODULE: ./components/shared/HeadMetadata.tsx
var HeadMetadata = __webpack_require__(73412);
// EXTERNAL MODULE: ./hooks/usePageTrack/index.ts + 1 modules
var usePageTrack = __webpack_require__(56002);
// EXTERNAL MODULE: ../../node_modules/next/dist/client/router.js
var router = __webpack_require__(93642);
// EXTERNAL MODULE: ./utils/app-urls.ts
var app_urls = __webpack_require__(62177);
;// CONCATENATED MODULE: ./pages/hiring-process-comparison.tsx









var parseJSON = function(resp) {
    return resp.json ? resp.json() : resp;
};
var checkStatus = function(resp) {
    if (resp.status >= 200 && resp.status < 300) {
        return resp;
    }
    return parseJSON(resp).then(function(resp) {
        throw resp;
    });
};
var headers = {
    "Content-Type": "application/json"
};
var HiringProcessComparisonPage = function(param) {
    var baseUrl = param.baseUrl;
    var t = (0,useI18n/* useI18n */.Q)("hiring-process-comparison").t;
    (0,usePageTrack/* usePageTrack */.N)("Landing - Page Loaded");
    var locale = (0,router.useRouter)().locale;
    var ref = (0,react.useState)([]), hiringProcess = ref[0], setHiringProcess = ref[1];
    var ref1 = (0,react.useState)([]), tips = ref1[0], setTips = ref1[1];
    var ref2 = (0,react.useState)([]), faqs = ref2[0], setFaqs = ref2[1];
    (0,react.useEffect)(function() {
        fetch("https://cms.getmanfred.com/api/hiring-processes?populate=%2A&pagination[pageSize]=100&locale=".concat(locale), {
            headers: headers,
            method: "GET"
        }).then(checkStatus).then(parseJSON).then(function(param) {
            var data = param.data;
            return setHiringProcess(data);
        });
    }, []);
    (0,react.useEffect)(function() {
        fetch("https://cms.getmanfred.com/api/hiring-process-tips?populate=%2A&locale=".concat(locale), {
            headers: headers,
            method: "GET"
        }).then(checkStatus).then(parseJSON).then(function(param) {
            var data = param.data;
            return setTips(data);
        });
    }, []);
    (0,react.useEffect)(function() {
        fetch("https://cms.getmanfred.com/api/hiring-process-faqs?populate=%2A&locale=".concat(locale), {
            headers: headers,
            method: "GET"
        }).then(checkStatus).then(parseJSON).then(function(param) {
            var data = param.data;
            return setFaqs(data);
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadMetadata/* default */.Z, {
                indexable: true,
                title: t("hiring-process-comparison.page_title"),
                url: app_urls/* APP_URLS.hiringProcessComparison */.uu.hiringProcessComparison,
                desc: t("hiring-process-comparison.page_description"),
                imgUrl: "".concat(baseUrl).concat((0,paths/* getPublicPath */.A)("/images/cards/hiring_process_comparison.png"))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(hiringProcessComparison_HPCComponent, {
                content: hiringProcess,
                tips: tips,
                faqs: faqs
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var hiring_process_comparison = (HiringProcessComparisonPage);


/***/ }),

/***/ 63201:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 81192:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 25237:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(95805)


/***/ }),

/***/ 12524:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = '';

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (arg) {
				classes = appendClass(classes, parseValue(arg));
			}
		}

		return classes;
	}

	function parseValue (arg) {
		if (typeof arg === 'string' || typeof arg === 'number') {
			return arg;
		}

		if (typeof arg !== 'object') {
			return '';
		}

		if (Array.isArray(arg)) {
			return classNames.apply(null, arg);
		}

		if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
			return arg.toString();
		}

		var classes = '';

		for (var key in arg) {
			if (hasOwn.call(arg, key) && arg[key]) {
				classes = appendClass(classes, key);
			}
		}

		return classes;
	}

	function appendClass (value, newClass) {
		if (!newClass) {
			return value;
		}
	
		if (value) {
			return value + ' ' + newClass;
		}
	
		return value + newClass;
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7482,3467,625,4882,7265,9774,2888,179], function() { return __webpack_exec__(33844); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);